import React from 'react';
import { IconLink } from '@bynder/icons';
import { SyntheticEvent } from 'react-draft-wysiwyg';
import styled from 'styled-components';
import { useTranslate } from '@bynder/localization';
import { notify, Button, Tooltip } from '@bynder/design-system';
import { getAlphaColor } from '../shared/styled-components/Header';
import { LinkCopiedToClipboardNotification } from '../../types/notifications';
import { copyShareUrlToClipboard } from '../../constants/widgets';

type ButtonProps = {
  entityId?: string;
  pageId?: string;
  color?: string;
};

export const CardShareLinkButton: React.FC<ButtonProps> = ({
  color,
  entityId,
  pageId,
}) => {
  const { translate } = useTranslate();

  const handleClick = (e: SyntheticEvent) => {
    e.stopPropagation();
    copyShareUrlToClipboard(entityId, pageId)
      .then(() => notify(LinkCopiedToClipboardNotification))
      .catch(e => {
        throw new Error(e);
      });
  };

  return (
    <Tooltip content={translate('SHARE_MODAL.BUTTON_TEXT')}>
      <StyledButton
        variant="secondary"
        aria-label="copyLink"
        onClick={handleClick}
        icon={<IconLink />}
        data-testid="shareLinkButton"
        $color={color}
      />
    </Tooltip>
  );
};

export const StyledButton = styled(Button)<{ $color: string }>`
  color: ${props =>
    props.$color ? getAlphaColor(0.6, props.$color) : 'inherit'};

  &:hover {
    color: ${props => props.$color ?? 'inherit'} !important;
    background-color: ${props =>
      props.$color ? getAlphaColor(0.03, props.$color) : 'inherit'};

    i {
      color: ${props => props.$color ?? 'inherit'};
    }
  }

  &:active,
  &:focus {
    color: ${props => props.$color ?? 'inherit'} !important;
    background-color: ${props => getAlphaColor(0.05, props.$color)};
  }
`;
